import { useState } from 'react';
import { generateRandomString } from '../utils/crypto';

const useCryptographicallyRandom = () => {
  const [randomString] = useState(generateRandomString());
  return { randomString };
};

export { useCryptographicallyRandom };
